import { useNavigate } from "react-router-dom";
// import "../../styles/home/home.css";
//import ParliamentCards from "../../components/info/ParliamentCards";
//import { FaCheckCircle } from "react-icons/fa";
import senate_head from "../../assets/backgroundinfo_senate_head.png";
import senate_right from "../../assets/backgroundinfo_senate_right.png";
import senate_search from "../../assets/backgroundinfo_senate_search.png";
import "../../styles/info/BackgroundInfo.css";

const BackgroundInfo = () => {
  const navigate = useNavigate();

  // const handleKnowMore = () => {
  //   // Add navigation logic here if needed
  //   console.log("Know More Clicked");
  //   // e.g., navigate('/learn-more');
  // };

  //const checklist = [
  //"I’m 18 Or Older",
  //"I’m An Australian Citizen",
  //"I’m Enrolled To Vote",
  //];

  return (
    <div className="home-container">
      <div className="info-background-section">
        <div className="overlay-blur">
          {/* <div className="overlay-content">
            <h1>
              New To Voting? <br /> Start Here
            </h1>
            <div className="vertical-spacer"></div>
            <div className="white-text">
              Everything You Need To Know About Parliament
              <br />
              And How To Vote — No Jargon, Just Answers.
            </div>
            <button onClick={() => navigate("/inforfrombackground")}>
              Know More
            </button>
          </div> */}
          <div className="intro-banner">
            <h1 className="intro-title">Welcome To Factaroo</h1>
            <div className="intro-subtitle-dev">
              {/* <h2 className="intro-subtitle">
                Empowering Young Votes With Facts
              </h2> */}
              <blockquote className="intro-quote">
                Our Mission Is To Help Young Australians Make Informed Voting
                Decisions By Providing Tools To Verify Political Claims Using
                Official Parliamentary Records.
              </blockquote>
            </div>

            <div className="intro-actions">
              <div
                className="intro-card"
                onClick={() => navigate("/inforfrombackground")}
              >
                <img
                  src={senate_head}
                  alt="senate_head"
                  className="intro-card-img"
                />
                <h3>Learn How Parliament Works</h3>
                <p></p>
              </div>
              <div
                className="intro-card"
                onClick={() => navigate("/challenge")}
              >
                <img
                  src={senate_right}
                  alt="senate_right"
                  className="intro-card-img"
                />
                <h3>Fact-Checking Challenges</h3>
                <p></p>
              </div>
              <div className="intro-card" onClick={() => navigate("/ask")}>
                <img
                  src={senate_search}
                  alt="senate_search"
                  className="intro-card-img"
                />
                <h3>Political Claims</h3>
                <p></p>
              </div>
            </div>

            <button
              className="intro-button"
              onClick={() => navigate("/info-detial")}
            >
              Click here to know more
            </button>
          </div>
        </div>
      </div>
      {/* <div className="background-section2">
        <div className="overlay-blur">
          <div className="overlay-content-static">
            <h1>Why does Parliament even matter?</h1>
            <div className="vertical-spacer"></div>
            <p>
              Parliament is where laws that affect your daily life are made —
              like housing, jobs, uni fees, and climate action.
            </p>
            <ParliamentCards />
          </div>
        </div>
      </div>

      <div className="vote-section">
        <h2>Do I Need To Vote?</h2>
        <ul className="vote-check-list">
          {checklist.map((item, index) => (
            <li key={index}>
              <FaCheckCircle className="check-icon" />
              <span>{item}</span>
            </li>
          ))}
        </ul>
      </div> */}

      {/* <div className="transparency-section">
        <h2>How Do I Know Who’s Actually Doing A Good Job?</h2>
        <div className="transparency-content">
          <img
            src={parliamentLayout}
            alt="Parliament Layout"
            className="parliament-img"
          />

          <div className="transparency-info">
            <div className="transparency-item">
              <div>
                <h3>🧾 Check how they voted: </h3>
                <p>
                  Did Your MP Support Climate Action? Cheaper Uni? <br />
                  You Can Look Up How They Voted On Real Bills In Parliament.
                </p>
              </div>
            </div>

            <div className="transparency-item">
              <div>
                <h3>📢 Read their speeches: </h3>
                <p>
                  What Did They Say In Parliament? You Can Search Debates And
                  Speeches <br />
                  Using Keywords Like “Housing” Or “Mental Health.”
                </p>
              </div>
            </div>

            <button className="try-now-btn" onClick={() => navigate("/ask")}>
              Try now
            </button>
          </div>
          <p className="transparency-footer">
            Don’t Just Go By Headlines. <br />
            Go By Their Record. <br />
            Politicians Must Show What They Support — And It’s Public.
          </p>
        </div>
      </div> */}
    </div>
  );
};

export default BackgroundInfo;
